module.exports = __webpack_public_path__ + "img/cognitive-behavioral-therapy.e231f11d.png";